"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyBlur = exports.blurs = void 0;
exports.blurs = {
    small: '27px',
    medium: '37px',
    large: '50px',
};
exports.applyBlur = function (_a) {
    var blur = _a.blur;
    return blur && "backdrop-filter: blur(" + exports.blurs[blur] + ");";
};
//# sourceMappingURL=blur.js.map